// src/pages/Home.tsx

import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import CategoryList from '../components/CategoryList';
import ProductCard from '../components/ProductCard';
import CartPage from './CartPage'; // Import the CartPage component

import { fetchCategories, fetchAllProducts } from '../utils/api';
import { Category, Product } from '../utils/types';
// import { useSettings } from '../context/SettingsContext';
import GoToTop from '../components/GoToTop';
import { useCart } from '../context/CartContext'; // Import Cart Context

const Home: React.FC = () => {

    const [categories, setCategories] = useState<Category[]>([]);
    const [productsByCategory, setProductsByCategory] = useState<{ [key: number]: Product[] }>({});
    // const [selectedCategory, setSelectedCategory] = useState<number | null>(null); //abb 5-12-24 null to 1 so default cat 1 appear
    const [selectedCategory, setSelectedCategory] = useState<number | null>(1);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>(''); // Define error as string
    // const [cartItems, setCartItems] = useState();

    const [isOrderTypeModalOpen, setOrderTypeModalOpen] = useState<boolean>(false); // New state for modal

    const navigate = useNavigate();

    const { cartItems } = useCart(); // Access cartItems from context

    // const orderType = localStorage.getItem('orderType');

    const vendorId = JSON.parse(localStorage.getItem('user') || '{}').vendor_id;
    // const vendorId = settings?.vendorId;
    // const token = localStorage.getItem('token');
    // const customerId = 0; // Include actual customer ID if available
    // const selectedTable = localStorage.getItem('selectedTable')
    //     ? JSON.parse(localStorage.getItem('selectedTable')!)
    //     : { id: 'You need to select a table' };  // Default table ID if not set
    // const orderType = localStorage.getItem('orderType') || 'You need to select an order type'; // Default order type if not set


    // Check if the user is authenticated
    useEffect(() => {
        const user = localStorage.getItem('user');

        // console.log(user);

        if (!user) {
            navigate('/login'); // Redirect to login if user is not authenticated
        }
    }, [navigate]);

    // const clearLocalStorageAndCart = () => {
    //     localStorage.clear();
    // };

    useEffect(() => {
        const loadCategories = async () => {
            try {
                // clearLocalStorageAndCart();

                const categoryData = await fetchCategories();
                setCategories(categoryData);
            } catch (err) {
                setError('Failed to load categories');
            }
        };

        loadCategories();
    }, []);

    useEffect(() => {
        const loadProducts = async () => {
            try {
                let allProducts = await fetchAllProducts(vendorId);
                let groupedProducts: { [key: number]: Product[] } = {};

                // Group products by category id
                categories.forEach((category) => {
                    groupedProducts[category.id] = allProducts.filter(
                        (product) => product.category_id === category.id
                    );
                });

                setProductsByCategory(groupedProducts);
                setLoading(false);
            } catch (err) {
                setError('Failed to load products');
            }
        };

        if (categories.length > 0) {
            loadProducts();
        }
    }, [categories, vendorId]);

    useEffect(() => {
        if (selectedCategory !== null) {
            // Scroll to products when a category is selected
            const categoryElement = document.getElementById(`category-${selectedCategory}`);
            if (categoryElement) {
                // categoryElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [selectedCategory]);

    const scrollableDivRef = useRef<HTMLDivElement>(null);

    const [totalQuantity, setTotalQuantity] = useState(0);

    useEffect(() => {
        const calculateTotals = () => {
            const filteredItems = cartItems.filter(item => !item.checkedOut);

            const newTotalQuantity = filteredItems.reduce((acc, item) => acc + item.quantity, 0);
            // const newTotalPrice = cartItems.reduce((acc, item) => acc + item.totalPrice, 0);
            setTotalQuantity(newTotalQuantity);
            // setTotalPrice(newTotalPrice);
        };

        calculateTotals();
    }, [cartItems]);

    // console.log('cartItems from home.tsx >> ', cartItems);

    return (
        <div className='w-full '>

            <div className="grid grid-cols-1 md:grid-cols-12">


                {/* Right Side: Categories and Products */}
                <div className="md:col-span-7 flex w-full   p-0 pb-28 m-0 mb-28 ">

                    <div className="border border-1 border-transparent w-3/12 md:w-1/5 m-0 p-0  overflow-x-hidden h-screen overflow-y-auto pb-32" style={{ backgroundColor: '#7a75b5' }}>
                        <CategoryList onSelectCategory={setSelectedCategory} />
                    </div>

                    <div className="border border-1 border-transparent  w-9/12 md:w-4/5 m-0 p-0 overflow-x-hidden h-screen overflow-y-auto pb-56" ref={scrollableDivRef} >

                        {loading && <p>Loading products...</p>}
                        {error && <p className="text-red-500">{error}</p>}

                        {/* Loop over each category and display products */}
                        {categories.map((category) => (
                            category.id === selectedCategory && ( // Only render if category matches selectedCategory
                                <div
                                    id={`category-${category.id}`}
                                    key={`key-${category.id}`}
                                    // className={`bg-white border p-2 rounded shadow cursor-pointer ${category.id === 1 ? 'pt-14' : 'pt-14'}`}
                                    className={`bg-white  p-2 rounded  cursor-pointer ${category.id === 1 ? 'pt-0' : 'pt-0'}`}
                                >

                                    <h2 className="text-md md:text-xl font-bold mx-0 mb-4 ">{category.name.toUpperCase()}&nbsp;{category.description.toUpperCase()}</h2>

                                    {/* <div className="flex flex-row flex-wrap mx-0 my-1 px-1 py-1 "> */}
                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1 mx-0 my-1 px-0 py-1 ">
                                        {productsByCategory[category.id]?.map((product) => (
                                            <ProductCard
                                                key={product.id}
                                                product={product}
                                                vendorId={vendorId}
                                                isInCart={cartItems.some(item => item.productId === product.id)} // Highlight if in cart

                                            />
                                        ))}
                                    </div>

                                    
                                </div>
                            )
                        ))}

                        <GoToTop parentRef={scrollableDivRef} />

                    </div>


                </div>

                {/* Left Side: CartPage (hidden on smaller screens) */}
                <aside className="md:col-span-5 hidden md:block md:w-full bg-gray-100 p-1 border-r  h-screen   pt-0">

                    <CartPage setOrderTypeModalOpen={setOrderTypeModalOpen} variant="embedded" /> {/* Correct function passed */}

                </aside>

            </div>


            {/* Floating button to redirect to cart */}
            {cartItems.length > 0 && (
                <button
                    onClick={() => navigate('/cart')}
                    className="fixed bottom-16 left-1 bg-yellow-300 text-purple-700 px-2 py-3 rounded-lg shadow-lg hover:bg-yellow-400 transition text-xs"
                >
                    Submit<br />Current ({totalQuantity})
                </button>
            )}

        </div>
    );
};

export default Home;
